import { a as fragmentDefaultComponentName } from "../common/consts.js";
import { i as isFederationEntry } from "../common/helpers.js";
import { u as useFragmentComponent } from "./component.js";
function useFragmentEntry(options) {
  const { injector, networkService, federationLocalization, processException } = options;
  const { id: entryId, fragmentName, entryName } = injector.__internal.inject("entryInfo");
  const components = /* @__PURE__ */ new Set();
  let remote;
  return {
    createComponent,
    getComponentNames,
    load
  };
  function createComponent(componentName = fragmentDefaultComponentName) {
    const unsubscribe = federationLocalization.subscribe();
    const componentInjector = injector.__internal.fork();
    const id = `${entryId}:${componentName}`;
    const componentInfo = { id, fragmentName, entryName, componentName };
    componentInjector.__internal.provide("componentInfo", componentInfo);
    const newComponent = useFragmentComponent({
      loadEntry: load,
      onDestroy: () => {
        components.delete(newComponent);
        unsubscribe();
      },
      injector: componentInjector,
      getDefine: () => getComponentDefine(componentName),
      processException: (error) => processException(error, { componentName, entryName })
    });
    components.add(newComponent);
    return newComponent;
  }
  function getComponentNames() {
    if (isFederationEntry(remote)) {
      const definitionComponents = Object.keys(remote.definition.components);
      return definitionComponents.sort(
        (a, b) => a === fragmentDefaultComponentName ? -1 : b === fragmentDefaultComponentName ? 1 : 0
      );
    }
    return [fragmentDefaultComponentName];
  }
  function getComponentDefine(name) {
    return isFederationEntry(remote) ? remote.definition.components[name] : remote;
  }
  async function load() {
    await Promise.all([
      setRemote(),
      federationLocalization.setLocalization(),
      networkService.insertStyles(entryName)
    ]);
  }
  async function setRemote() {
    remote = await networkService.importModule(entryName);
  }
}
export {
  useFragmentEntry as u
};
//# sourceMappingURL=entry.js.map
